import React, { useRef, useState } from 'react'
import clsx from 'clsx'
import Icon from '../Icon'
import Button from '../Button'
import Heading from '../Heading'

import './contactform.scss'
import { CustomToast } from '../../utils/helpers'

function encode(data) {
  const formData = new FormData()
  for (const key of Object.keys(data)) {
    formData.append(key, data[key])
  }
  return formData
}

export const ContactForm = ({ otherClasses, toggleCancel }) => {
  const contactFormClasses = clsx(
    otherClasses,
    'max-w-[720px] bg-white overflow-y-auto h-full'
  )
  const [toggle, setToggle] = useState('message')
  const handleToggle = (elm) => {
    setToggle(elm)
  }

  const [state, setState] = useState({
    name: '',
    phone: '',
    email: '',
    'what-can-we-help-you-with': '',
    description: '',
    optIn: true,
  })
  const handleChange = (e) => {
    setState((state) => ({
      ...state,
      [e.target.name]: e.target.value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const form = e.target
    try {
      await fetch('/', {
        method: 'POST',
        body: encode({
          'form-name': form.getAttribute('name'),
          ...state,
        }),
      })
      CustomToast(
        'Thank you for for submission! We will get in touch with you shortly.'
      )
      setState({
        name: '',
        phone: '',
        email: '',
        'what-can-we-help-you-with': '',
        description: '',
        optIn: true,
      })
      form.reset()
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div className={contactFormClasses} data-testid="contact-form">
      <div className="flex justify-between items-center px-6 py-4 border-b-[1px] border-b-gray_200">
        <div className="flex items-center gap-2 cursor-pointer">
          <Icon icon="phone" iconHeight={24} iconWidth={24} />
          <a
            href="tel:6476979595"
            className="font-work-sans text-primary_blue_600 font-semibold text-sm tracking-[0.42px] "
          >
            (647) 697-9595
          </a>
        </div>
        <button onClick={() => toggleCancel()}>
          <Icon icon="Close" iconHeight={20} iconWidth={20} />
        </button>
      </div>
      <div className="pb-6 px-6  lg:px-10 w-full">
        <Heading
          type="h2"
          otherClasses="text-center text-4xl font-work-sans font-bold text-primary_heading_color my-10"
        >
          Contact Us
        </Heading>
        <div className="flex items-center rounded-3xl overflow-hidden mb-6">
          <button
            onClick={() => handleToggle('meeting')}
            className={clsx(
              'font-work-sans text-sm lg:text-base font-semibold leading-6 w-full px-6 py-2 lg:px-8 lg:py-3 text-center whitespace-nowrap',
              toggle === 'meeting'
                ? 'text-white bg-blue-500'
                : 'text-gray-600 bg-primary_blue_50'
            )}
          >
            Book a Meeting
          </button>
          <button
            onClick={() => handleToggle('message')}
            className={clsx(
              'font-work-sans text-sm lg:text-base font-semibold leading-6 w-full px-6 py-2 lg:px-8 lg:py-3 text-center whitespace-nowrap',
              toggle === 'message'
                ? 'text-white bg-blue-500'
                : 'text-gray-600 bg-primary_blue_50'
            )}
          >
            Send a Message
          </button>
        </div>
        <form
          method="post"
          onSubmit={handleSubmit}
          action=""
          name="Contact Us"
          className={clsx(
            'w-full mt-5 md:mt-8',
            toggle === 'meeting' ? 'hidden' : 'block'
          )}
        >
          <div className="mb-6">
            <label
              htmlFor="name"
              className="font-work-sans text-base  font-semibold leading-6 text-primary_heading_color"
            >
              Name
            </label>
            <input
              name="name"
              id="name"
              required
              type="text"
              value={state.name}
              onChange={(e) =>
                setState((prev) => ({
                  ...prev,
                  name: e?.target.value,
                }))
              }
              className="w-full border-[1px] font-work-sans border-gray-500 rounded-3xl py-[13px] px-4 h-12 mt-2 focus:border-primary_blue_600 outline-offset-2 outline-[3px] outline-[#0170B9]/30"
            />
          </div>
          <div className="mb-6 flex flex-col md:flex-row gap-5 lg:gap-[21px]">
            <div className="w-full md:w-2/4">
              <label
                htmlFor="phone"
                className="font-work-sans text-base font-semibold leading-6 text-primary_heading_color"
              >
                Phone Number
              </label>
              <input
                name="phone"
                id="phone"
                required
                value={state.phone}
                onChange={(e) =>
                  setState((prev) => ({
                    ...prev,
                    phone: e?.target.value,
                  }))
                }
                type="number"
                className="w-full border-[1px] font-work-sans border-gray-500 rounded-3xl py-[13px] px-4  h-12 mt-2 focus:border-primary_blue_600 outline-offset-2 outline-[3px] outline-[#0170B9]/30"
              />
            </div>
            <div className="w-full md:w-2/4">
              <label
                htmlFor="email"
                className="font-work-sans text-base  font-semibold leading-6 text-primary_heading_color"
              >
                Email Address
              </label>
              <input
                name="email"
                id="email"
                required
                type="email"
                value={state.email}
                onChange={(e) =>
                  setState((prev) => ({
                    ...prev,
                    email: e?.target.value,
                  }))
                }
                className="w-full border-[1px] font-work-sans border-gray-500 rounded-3xl py-[13px] px-4  h-12 mt-2 focus:border-primary_blue_600  outline-offset-2 outline-[3px] outline-[#0170B9]/30"
              />
            </div>
          </div>
          <div className="mb-6 flex flex-col md:flex-row gap-5 lg:gap-[21px]">
            <div className="w-full">
              <label
                htmlFor="drop-down"
                className="font-work-sans text-base font-semibold leading-6 text-primary_heading_color"
              >
                What Can We Help You With?
              </label>
              <select
                id="drop-down"
                type="text"
                value={state['what-can-we-help-you-with']}
                onChange={(e) =>
                  setState((prev) => ({
                    ...prev,
                    'what-can-we-help-you-with': e?.target.value,
                  }))
                }
                required
                name="what-can-we-help-you-with"
                className="w-full border-[1px]  border-gray-500 mt-1 rounded-3xl flex justify-between px-4 h-12 items-center   text-xl leading-[30px] text-gray-900 font-normal font-work-sans focus:ring-0 focus:border-primary_blue_600  focus:border-[1px] focus:outline-offset-2 focus:outline-[3px] focus:outline-[#0170B9]/30"
              >
                <option selected disabled value="" className="text-gray-900">
                  Other
                </option>
                <option value="Pre-construction" className="text-gray-900">
                  Pre-construction
                </option>
                <option value="Assignment Sale" className="text-gray-900">
                  Assignment Sale
                </option>
                <option value="Worksheet" className="text-gray-900">
                  Worksheet
                </option>
              </select>
            </div>
          </div>
          <div className="w-full">
            <label
              htmlFor="description"
              className="font-work-sans text-base font-semibold leading-6 text-primary_heading_color"
            >
              Message (optional)
            </label>
            <textarea
              type="text"
              value={state.description}
              onChange={(e) =>
                setState((prev) => ({
                  ...prev,
                  description: e?.target.value,
                }))
              }
              name="description"
              id="description"
              cols="30"
              rows="10"
              className="w-full border-[1px] font-Roboto px-4 py-[13px] border-gray-500 rounded-3xl min-h-[136px] max-h-[136px] mt-2 focus:border-primary_blue_600 outline-offset-2 outline-[3px] outline-[#0170B9]/30 resize-none"
            ></textarea>
          </div>
          <div className="flex gap-2 mb-4">
            <input
              type="checkbox"
              name="optIn"
              id="optIn"
              checked={state.optIn}
              onChange={() =>
                setState((prev) => ({
                  ...prev,
                  optIn: !state.optIn,
                }))
              }
              className="basis-[24px] shrink-0 grow-0 h-[24px] form-input regular_check_box"
            />
            <label
              htmlFor="optIn"
              className="font-work-sans text-base leading-6 text-primary_heading_color hidden lg:block"
            >
              I agree to be contacted by All Access Homes via call, email and
              text. To opt out, you can reply 'stop' at any time or click the
              unsubscribe link in the emails. For more information see our{' '}
              <a href="/privacy-policy" className="text-[#0170b9]">
                privacy policy
              </a>
              . Message and data rates may apply.
            </label>
            <label
              htmlFor="optIn"
              className="font-work-sans text-base leading-6 text-primary_heading_color lg:hidden"
            >
              I agree to receive marketing and customer service calls and text
              messages from All Access Homes. Msg/data rates may apply. Msg
              frequency varies. Reply STOP to unsubscribe.{' '}
              <a href="/privacy-policy" className="text-[#0170b9]">
                Privacy Policy
              </a>{' '}
              &{' '}
              <a href="/terms-and-conditions/" className="text-[#0170b9]">
                Terms
              </a>
              .
            </label>
          </div>
          <div
            className={clsx(
              'w-full items-end mt-10 justify-end border-t-[1px] border-t-gray-100 py-4 px-10',
              toggle === 'message' ? 'flex' : 'hidden'
            )}
          >
            <Button label="Submit" />
          </div>
        </form>
      </div>
      <div
        className={clsx(
          'font-work-sans pl-10 text-6xl font-semibold text-gray-900',
          toggle === 'meeting' ? 'block' : 'hidden'
        )}
      >
        <iframe
          name="__privateStripeMetricsController1040"
          src="https://calendly.com/ryan-allaccesshomes/book-appointment?month=2023-09"
          aria-hidden="true"
          tabindex="-1"
          className="w-full h-[600px]"
        ></iframe>
      </div>
    </div>
  )
}

export default ContactForm
